import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const OwnerLoader = props => {
        return(<>
    {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => (
                    <ContentLoader 
                    rtl
                    height={35}
                    width={340}
                    speed={2}
                    key={i+1}
                >
                    <circle cx="24.64" cy="19.47" r="15.8" /> 
                    <rect x="41.84" y="7.67" rx="10" ry="10" width="134" height="9.54" /> 
                    <rect x="42.84" y="19.67" rx="10" ry="10" width="134" height="9.54" />
                </ContentLoader>  ))
            )}</>)
}